import { ReactNode } from "react";
import { Box, Paper } from "@mui/material";
import { Button, Checkbox } from "antd";
import { ClearOutlined, SaveOutlined } from "@ant-design/icons";
import { COLOR_PRIMARY, COLOR_SECONDARY } from "../../../constants";

/** Tarjeta corporativa para los formularios de crear/editar. */
export const FormPaper = ({ children }: { children: ReactNode }) => (
  <Paper
    elevation={0}
    sx={{
      m: 1,
      mt: 2,
      overflow: "hidden",
      borderRadius: "12px",
      boxShadow: "0 8px 28px rgba(3, 5, 33, 0.14)",
      "& .MuiInputLabel-root.Mui-focused": { color: COLOR_SECONDARY },
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        "&.Mui-focused fieldset": { borderColor: COLOR_SECONDARY },
      },
    }}
  >
    {children}
  </Paper>
);

interface FormHeaderPropsI {
  title: string;
  subtitle?: string;
  isProcessing?: boolean;
  onClear?: () => void;
  /** Controles extra (checkbox, switches) mostrados antes de los botones. */
  extra?: ReactNode;
}

export const FormHeader = ({
  title,
  subtitle,
  isProcessing,
  onClear,
  extra,
}: FormHeaderPropsI) => (
  <Box
    sx={{
      background: COLOR_PRIMARY,
      borderBottom: `4px solid ${COLOR_SECONDARY}`,
      px: 3,
      py: 1.75,
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      flexWrap: "wrap",
    }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        lineHeight: 1.25,
        flex: 1,
        minWidth: 180,
      }}
    >
      <span style={{ color: "#fff", fontSize: 18, fontWeight: 600 }}>
        {title}
      </span>
      {subtitle ? (
        <span style={{ color: "rgba(255,255,255,0.65)", fontSize: 12 }}>
          {subtitle}
        </span>
      ) : null}
    </Box>
    {extra}
    {onClear ? (
      <Button
        ghost
        disabled={isProcessing}
        icon={<ClearOutlined />}
        onClick={onClear}
        style={{
          color: "#fff",
          borderColor: "rgba(255,255,255,0.45)",
          fontWeight: 600,
        }}
      >
        Limpiar
      </Button>
    ) : null}
    <Button
      type="primary"
      htmlType="submit"
      loading={isProcessing}
      disabled={isProcessing}
      icon={<SaveOutlined />}
      style={{
        background: COLOR_SECONDARY,
        borderColor: COLOR_SECONDARY,
        fontWeight: 600,
      }}
    >
      Guardar
    </Button>
  </Box>
);

export const FormBody = ({ children }: { children: ReactNode }) => (
  <Box sx={{ p: 3, pt: 3.5 }}>{children}</Box>
);

/** Checkbox con texto claro para colocar sobre el encabezado oscuro. */
export const FormHeaderCheck = ({
  checked,
  onChange,
  label,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}) => (
  <Checkbox
    checked={checked}
    onChange={(e) => onChange(e.target.checked)}
    style={{ color: "#fff", fontWeight: 600 }}
  >
    {label}
  </Checkbox>
);
